import { Battery } from 'lucide-react';
import { bessFlow, formatMw } from './derive';

interface BessTileProps {
  socPct: number | null;
  bessPowerKw: number | null;
  dimmed: boolean;
}

export function BessTile({ socPct, bessPowerKw, dimmed }: BessTileProps) {
  const flow = bessPowerKw != null ? bessFlow(bessPowerKw) : null;
  return (
    <div className={`rounded-xl bg-ems-bg p-2.5 ${dimmed ? 'opacity-50' : ''}`}>
      <div className="flex items-center gap-1 text-[10px] font-semibold uppercase tracking-wider text-ems-text-muted">
        <Battery className="h-3 w-3" /> BESS
      </div>
      <div className="mt-1 font-mono text-base font-bold text-ems-blue">
        {socPct != null ? (
          <>
            {Math.round(socPct)}
            <span className="text-xs">%</span>{' '}
            <span className="text-[11px] font-normal text-ems-text-secondary">SOC</span>
          </>
        ) : (
          <span className="text-ems-text-primary">—</span>
        )}
      </div>
      {flow != null && bessPowerKw != null && (
        <div className="text-[11px] text-ems-text-secondary">
          {flow === 'idle' ? (
            '— idle'
          ) : (
            <>
              {flow === 'charging' ? '⇣ charging ' : '⇡ discharging '}
              <span className="font-mono">{formatMw(Math.abs(bessPowerKw))} MW</span>
            </>
          )}
        </div>
      )}
    </div>
  );
}
